import { FileDownloadService } from "@topline/services/fileDownloadService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ToasterService } from "@topline/services/toasterService";
(function (module) {
    "use strict";

    module.component("productPpgChart", {
        template: require("./productPpgChartComponent.html"),
        bindings: {
            marketPmForecast: "<",
            marketStatisticalForecast: "<",
            historicalMarketValue: "<",
            brandPmForecast: "<",
            brandStatisticalForecast: "<",
            brandPmForecastAfterCorrection: "<",
            brandStatisticalForecastAfterCorrection: "<",
            hasForecastCorrection: "<",
            historicalBrandValue: "<",
            parameters: "<",
            numberPrecision: "@",
            toggleContainer: "<",
            showInMilions: "<"
        },
        controller: [
            "$scope",
            angularServicesNames.$translate,
            "PPGChartAndTableService",
            "$timeout",
            ToasterService.componentName,
            FileDownloadService.componentName,
            "FileSaver",
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                PPGChartAndTableService: $TSFixMe,
                $timeout: ng.ITimeoutService,
                toasterService: ToasterService,
                fileDownloadService: FileDownloadService,
                FileSaver: $TSFixMe
            ) {
                const $ctrl = this;

                $ctrl.isCollapsed = {};

                $ctrl.showYears = true;

                function refreshDebounce() {
                    if (angular.isDefined($scope.watchTimeout)) {
                        $timeout.cancel($scope.watchTimeout);
                    }
                    $scope.watchTimeout = $timeout(function () {
                        recalculateChart();
                    }, 300);
                }

                function recalculateChart() {
                    if (!$ctrl.parameters || !$ctrl.parameters.historicalDataStart || !$ctrl.parameters.forecastEndDate)
                        return;

                    $ctrl.labels = PPGChartAndTableService.prepareLabelsToPPG(
                        $ctrl.parameters.historicalDataStart,
                        $ctrl.parameters.forecastEndDate
                    );
                    $ctrl.marketData = PPGChartAndTableService.calculatePPG(
                        $ctrl.parameters,
                        $ctrl.historicalMarketValue,
                        $ctrl.marketPmForecast,
                        $ctrl.marketStatisticalForecast
                    );
                    $ctrl.brandData = PPGChartAndTableService.calculatePPG(
                        $ctrl.parameters,
                        $ctrl.historicalBrandValue,
                        $ctrl.brandPmForecast,
                        $ctrl.brandStatisticalForecast
                    );
                    $ctrl.brandDataAfterCorrection = PPGChartAndTableService.calculatePPG(
                        $ctrl.parameters,
                        $ctrl.historicalBrandValue,
                        $ctrl.brandPmForecastAfterCorrection,
                        $ctrl.brandStatisticalForecastAfterCorrection
                    );

                    //set to filds that are bind to components
                    $ctrl.quarterTable = quarterTable(
                        $ctrl.marketData.ppg,
                        $ctrl.brandData.ppg,
                        $ctrl.brandDataAfterCorrection.ppg
                    );
                    $ctrl.quarterTangents = quarterTable(
                        $ctrl.marketData.ppg,
                        $ctrl.brandData.ppg,
                        $ctrl.brandDataAfterCorrection.ppg
                    );

                    $ctrl.chartData = _.filter(
                        [
                            $ctrl.marketData.yearlySum,
                            $ctrl.marketData.ppg.itemPPG,
                            $ctrl.brandData.yearlySum,
                            $ctrl.brandDataAfterCorrection.yearlySum,
                            $ctrl.brandData.ppg.itemPPG,
                            $ctrl.brandDataAfterCorrection.ppg.itemPPG
                        ],
                        (x: $TSFixMe) => angular.isArray(x)
                    );

                    $ctrl.tableData = _.filter(
                        [
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.MARKET"),
                                data: $ctrl.marketData.yearlySum,
                                isPercentage: false
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.MARKET_PM_PPG"),
                                data: $ctrl.marketData.ppg.itemPPG,
                                isPercentage: true
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.MARKET_STAT_PPG"),
                                data: $ctrl.marketData.ppg.itemStatisticalPPG,
                                isPercentage: true
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT"),
                                data: $ctrl.brandData.yearlySum,
                                isPercentage: false
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT_AFTER_CORRECTION"),
                                data: $ctrl.brandDataAfterCorrection.yearlySum,
                                isPercentage: false
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT_PM_PPG"),
                                data: $ctrl.brandData.ppg.itemPPG,
                                isPercentage: true
                            },
                            {
                                header: $translate.instant(
                                    "FORECAST.PRODUCT.PPG_CHART.PRODUCT_PM_PPG_AFTER_CORRECTION"
                                ),
                                data: $ctrl.brandDataAfterCorrection.ppg.itemPPG,
                                isPercentage: true
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT_STAT_PPG"),
                                data: $ctrl.brandData.ppg.itemStatisticalPPG,
                                isPercentage: true
                            },
                            {
                                header: $translate.instant(
                                    "FORECAST.PRODUCT.PPG_CHART.PRODUCT_STAT_PPG_AFTER_CORRECTION"
                                ),
                                data: $ctrl.brandDataAfterCorrection.ppg.itemStatisticalPPG,
                                isPercentage: true
                            }
                        ],

                        (x: $TSFixMe) => angular.isArray(x.data)
                    );
                    resetChartTranslations();
                }

                function quarterTable(marketPpg: $TSFixMe, brandPpg: $TSFixMe, brandAfterCorrectionPPg: $TSFixMe) {
                    return _.filter(
                        [
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.MARKET"),
                                data: marketPpg.quarterValue,
                                isPercentage: false
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.MARKET_PM_PPG"),
                                data: marketPpg.tangentQuarterPPG,
                                isPercentage: true
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.MARKET_STAT_PPG"),
                                data: marketPpg.statisticalTangentQuarter,
                                isPercentage: true
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT"),
                                data: brandPpg.quarterValue,
                                isPercentage: false
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT_AFTER_CORRECTION"),
                                data: brandAfterCorrectionPPg.quarterValue,
                                isPercentage: false
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT_PM_PPG"),
                                data: brandPpg.tangentQuarterPPG,
                                isPercentage: true
                            },
                            {
                                header: $translate.instant(
                                    "FORECAST.PRODUCT.PPG_CHART.PRODUCT_PM_PPG_AFTER_CORRECTION"
                                ),
                                data: brandAfterCorrectionPPg.tangentQuarterPPG,
                                isPercentage: true
                            },
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT_STAT_PPG"),
                                data: brandPpg.statisticalTangentQuarter,
                                isPercentage: true
                            },
                            {
                                header: $translate.instant(
                                    "FORECAST.PRODUCT.PPG_CHART.PRODUCT_STAT_PPG_AFTER_CORRECTION"
                                ),
                                data: brandAfterCorrectionPPg.statisticalTangentQuarter,
                                isPercentage: true
                            }
                        ],
                        (x: $TSFixMe) => angular.isArray(x.data)
                    );
                }

                $scope.$on("LanguageChanged", () => resetChartTranslations());
                resetChartTranslations();

                function resetChartTranslations() {
                    $translate([
                        "FORECAST.PRODUCT.PPG_CHART.MARKET",
                        "FORECAST.PRODUCT.PPG_CHART.MARKET_PPG",
                        "FORECAST.PRODUCT.PPG_CHART.PRODUCT",
                        "FORECAST.PRODUCT.PPG_CHART.PRODUCT_PPG",
                        "FORECAST.PRODUCT.PPG_CHART.PRODUCT_AFTER_CORRECTION",
                        "FORECAST.PRODUCT.PPG_CHART.PRODUCT_PM_PPG_AFTER_CORRECTION"
                    ]).then(function (translations: $TSFixMe) {
                        $ctrl.datasetOverride = [];
                        if ($ctrl.marketData && $ctrl.marketData.yearlySum) {
                            $ctrl.datasetOverride.push({
                                label: translations["FORECAST.PRODUCT.PPG_CHART.MARKET"],
                                type: "bar",
                                yAxisID: "y-value",
                                borderColor: "rgba(142, 83, 159, 0.6)",
                                backgroundColor: "rgba(142, 83, 159, 0.6)"
                            });
                        }
                        if ($ctrl.marketData && $ctrl.marketData.ppg.itemPPG) {
                            $ctrl.datasetOverride.push({
                                label: translations["FORECAST.PRODUCT.PPG_CHART.MARKET_PPG"],
                                type: "line",
                                yAxisID: "y-ppg",
                                borderColor: "rgba(0,71,133, 1)",
                                backgroundColor: "rgba(0,71,133, 1)"
                            });
                        }

                        if ($ctrl.brandData && $ctrl.brandData.yearlySum) {
                            $ctrl.datasetOverride.push({
                                label: translations["FORECAST.PRODUCT.PPG_CHART.PRODUCT"],
                                type: "bar",
                                yAxisID: "y-value",
                                borderColor: "rgba(198, 72, 3, 0.6)",
                                backgroundColor: "rgba(198, 72, 3, 0.6)"
                            });
                        }
                        if ($ctrl.brandDataAfterCorrection && $ctrl.brandDataAfterCorrection.yearlySum) {
                            $ctrl.datasetOverride.push({
                                label: translations["FORECAST.PRODUCT.PPG_CHART.PRODUCT_AFTER_CORRECTION"],
                                type: "bar",
                                yAxisID: "y-value",
                                borderColor: "rgba(177, 10, 186, 0.8)",
                                backgroundColor: "rgba(177, 10, 186, 0.8)"
                            });
                        }
                        if ($ctrl.brandData && $ctrl.brandData.ppg.itemPPG) {
                            $ctrl.datasetOverride.push({
                                label: translations["FORECAST.PRODUCT.PPG_CHART.PRODUCT_PPG"],
                                type: "line",
                                yAxisID: "y-ppg",
                                borderColor: "rgba(106, 178, 12, 1)",
                                backgroundColor: "rgba(106, 178, 12, 1)"
                            });
                        }
                        if ($ctrl.brandDataAfterCorrection && $ctrl.brandDataAfterCorrection.ppg.itemPPG) {
                            $ctrl.datasetOverride.push({
                                label: translations["FORECAST.PRODUCT.PPG_CHART.PRODUCT_PM_PPG_AFTER_CORRECTION"],
                                type: "line",
                                yAxisID: "y-ppg",
                                borderColor: "rgba(195, 8, 7, 0.8)",
                                backgroundColor: "rgba(195, 8, 7, 0.8)"
                            });
                        }
                    });
                }

                $ctrl.isNaN = (x: $TSFixMe) => isNaN(x);

                $ctrl.exportTable = () => {
                    toasterService.showReportGenerateBusyIndicator(
                        () =>
                            fileDownloadService.exportTable("table.xlsx", {
                                columns: $ctrl.labels,

                                rows: _.map($ctrl.tableData, (x: $TSFixMe) => {
                                    return {
                                        header: x.header,
                                        values: x.data,
                                        decimalPlaces: x.isPercentage ? 2 : parseInt($ctrl.numberPrecision),
                                        isPercentage: x.isPercentage
                                    };
                                })
                            }),
                        "EXCEL_EXPORT_GENERATING",
                        "EXCEL_EXPORT_GENERATED"
                    );
                };

                $scope.$on("chart-create", (e: $TSFixMe, chartInstance: $TSFixMe) => {
                    $ctrl.chartInstance = chartInstance;
                });

                $ctrl.exportChart = (event: $TSFixMe) => {
                    var canvas = $ctrl.chartInstance.chart.canvas;
                    canvas.toBlob(
                        function (blob: $TSFixMe) {
                            FileSaver.saveAs(blob, "wykres.png");
                        },
                        "image/png",
                        1
                    );
                };

                $ctrl.$onInit = function () {
                    if (angular.isUndefinedOrNull($ctrl.numberPrecision)) {
                        $ctrl.numberPrecision = 2;
                    }
                    $scope.$watch("$ctrl.historicalMarketValue", refreshDebounce, true);
                    $scope.$watch("$ctrl.marketPmForecast", refreshDebounce, true);
                    $scope.$watch("$ctrl.historicalBrandValue", refreshDebounce, true);
                    $scope.$watch("$ctrl.brandPmForecast", refreshDebounce, true);

                    $ctrl.options = {
                        scales: {
                            yAxes: [
                                {
                                    id: "y-value",
                                    display: true,
                                    position: "left",
                                    ticks: {
                                        suggestedMin: 0
                                    }
                                },
                                {
                                    id: "y-ppg",
                                    display: true,
                                    position: "right",
                                    ticks: {
                                        suggestedMin: 0
                                    }
                                }
                            ]
                        },
                        tooltips: {
                            callbacks: {
                                label: function (tooltipItem: $TSFixMe, data: $TSFixMe) {
                                    var label = data.datasets[tooltipItem.datasetIndex].label || "";

                                    if (label) {
                                        label += ": ";
                                    }
                                    var precision =
                                        data.datasets[tooltipItem.datasetIndex].yAxisID == "y-value"
                                            ? parseInt($ctrl.numberPrecision)
                                            : 2;
                                    label += tooltipItem.yLabel.toFixed(precision);
                                    if (data.datasets[tooltipItem.datasetIndex].yAxisID == "y-ppg") {
                                        label += " %";
                                    }
                                    return label.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                                }
                            }
                        }
                    };
                };
            }
        ]
    });
})(angular.module("topline.modules"));
